<!--
    视频模块
-->
<template>
    <div class="video">
        <div id="video">
            <video data-v-3b1260f5="" id="vido_one" :src="src"
            controls="controls"
            webkit-playsinline="" :poster="poster"
            playsinline="" x5-video-player-type="h5" class="video__player poster">
                抱歉，您的浏览器不支持内嵌视频
            </video>
        </div>  
    </div>
</template>
<script>
    export default {
        props:['src','poster']
    }
</script>
<style lang="less" scoped>
    .video{
        display:flex;
        align-items: center;
        justify-content: center;
        &-tit{
            width:calc(100% - 94px);
            padding-top:40px;
            margin-left:auto;
            margin-right:auto;
        }
        video{
            width:100%;
            height:200px;
            margin-left:auto;
            margin-right:auto;
        }
    }
</style>